import {Form, Formik} from 'formik'
import {isEmpty} from 'lodash'
import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import Modal from 'rsuite/Modal'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import * as Yup from 'yup'
import {safeText} from 'src/cms/helpers/validation/safeText'
import {KeyModel} from '../Model'
import * as groupSetting from '../index'

type Props = {
  open: boolean
  handleClose: () => void
  actionType: string
  editSelectedData?: any
}

const AddKey = ({open, handleClose, actionType, editSelectedData}: Props) => {
  const dispatch = useDispatch()
  const {loading, success} = useSelector((state: any) => state.groupSetting)

  const FORM_VALIDATION = Yup.object().shape({
    name: safeText().required('Name is required'),
  })

  useEffect(() => {
    if (success) {
      dispatch(groupSetting?.actions.getKey())
      isEmpty(editSelectedData)
        ? toast.success('GROUP name added successfully')
        : toast.success('GROUP name edited successfully')
      dispatch(groupSetting?.actions?.createKeyReset())
      handleClose()
    }
  }, [success])

  return (
    <div className='modal-container' data-cy='modal-group-setting'>
      <Modal
        open={open}
        onClose={handleClose}
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>{actionType} GROUP Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              initialValues={{
                name: '',
              }}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values: KeyModel, {setSubmitting}) => {
                if (!isEmpty(editSelectedData)) {
                  dispatch(groupSetting.actions.updateKey(values, editSelectedData?.id))
                } else {
                  dispatch(groupSetting.actions.createKey(values))
                }
              }}
              data-cy='group-setting-form'
            >
              {({isSubmitting, touched, handleChange, errors, values, setFieldValue}) => {
                useEffect(() => {
                  if (!isEmpty(editSelectedData)) {
                    const fields = ['name']
                    fields.forEach((field) => setFieldValue(field, editSelectedData[field], false))
                  }
                }, [])

                return (
                  <Form>
                    <div className='card-body border-top pt-5 pb-5'>
                      <FormTextBox
                        labelClassName='col-12'
                        containerClassName='col-lg-12 '
                        type='text'
                        placeholder='Name '
                        label='Name'
                        name='name'
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        required={true}
                        data-cy='group-setting-text-field'
                      />
                    </div>

                    <div className='d-flex justify-content-end px-5 '>
                      <button
                        type='submit'
                        disabled={loading}
                        className='btn btn-primary btn-sm ms-3'
                        data-cy='modal-submit'
                      >
                        Save
                      </button>
                      <button
                        type='button'
                        onClick={handleClose}
                        className='btn btn-secondary btn-sm ms-3'
                        data-cy='modal-cancel'
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default AddKey
